import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
/**
 * ReceiptSubTotal
 */
export const receiptSubTotalStyles = ({ theme }) => css `
	margin: 0;
	color: ${theme.colors.base.textPriceReceipt};
`;
export const StyledReceiptSubTotal = styled(Typography).attrs({
    variant: 'price-text-slim-s',
    tagName: 'div',
}) `
	${receiptSubTotalStyles}
`;
